export default function FaqHero() {
  return (
    <section className="relative bg-gradient-to-br from-slate-50 via-white to-amber-50/30 pt-32 pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-[#1A2332]/10 text-[#1A2332] px-4 py-2 rounded-full text-sm font-medium mb-6">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-question-line text-base"></i>
          </div>
          Frequently Asked Questions
        </div>

        <h1 className="text-5xl md:text-6xl font-bold text-[#1A2332] mb-4 leading-tight">
          You Have Questions.
          <span className="block text-[#E8B84B]">We Have Answers.</span>
          <span className="block text-2xl md:text-3xl font-normal text-slate-500 mt-2">
            (Unlike that one dealer who said "let me check with my manager" and never came back.)
          </span>
        </h1>

        <p className="text-xl text-slate-700 leading-relaxed max-w-2xl mx-auto mt-6">
          Everything you need to know about buying from Rockhound Auto —
          from financing to delivery to our $250 flat doc fee.{' '}
          <span className="text-slate-500 italic">No runaround. No hold music. Just answers.</span>
        </p>

        <div className="mt-10 flex flex-wrap justify-center gap-6">
          {[
            { stat: '$250', label: 'Doc fee. Flat. Always.', sub: 'Not $895. Not "market rate." $250.' },
            { stat: '0', label: 'Hidden fees', sub: 'We checked. Still zero.' },
            { stat: '< 1 hr', label: 'Average reply time', sub: 'Faster than your dealer\'s hold music.' },
          ].map((item) => (
            <div key={item.stat} className="bg-white border border-[#E8E2D6] rounded-xl px-6 py-4 shadow-sm text-center min-w-[160px]">
              <div className="text-3xl font-black text-[#1A2332]" style={{ fontFamily: 'Oswald, sans-serif' }}>{item.stat}</div>
              <div className="text-sm font-semibold text-[#1A2332] mt-1">{item.label}</div>
              <div className="text-xs text-slate-400 mt-0.5 italic">{item.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
